import React, { HtmlHTMLAttributes } from 'react';

import { Icon } from '../Icon';
import { colors } from '../../styles/tokens';
import { Container } from './styles';

interface textInfoProps extends HtmlHTMLAttributes<HTMLDivElement> {
  text: string;
}

const TextInfo: React.FC<textInfoProps> = ({ text, ...rest }) => {
  return (
    <Container {...rest}>
      <Icon name="info" size={18} color={colors.onSurfaceVariant} />
      <span>{text}</span>
    </Container>
  );
};

export { TextInfo };
